import { render, staticRenderFns } from "./knowledgeMenu.vue?vue&type=template&id=45ca72d5&scoped=true&lang=pug"
import script from "./knowledgeMenu.vue?vue&type=script&lang=js"
export * from "./knowledgeMenu.vue?vue&type=script&lang=js"
import style0 from "./knowledgeMenu.vue?vue&type=style&index=0&id=45ca72d5&prod&lang=scss&scoped=true"
import style1 from "./knowledgeMenu.vue?vue&type=style&index=1&id=45ca72d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca72d5",
  null
  
)

export default component.exports